// extracted by mini-css-extract-plugin
export default {"banner":"SimBanner_banner__b67ip","scan":"SimBanner_scan__gPj87","dot":"SimBanner_dot__U+B-s","pulse":"SimBanner_pulse__OqFla","text":"SimBanner_text__buk+W"};